import { useEffect, useState } from "react";

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/08e704a3966270a4e967243a9bb2e9e1.jpg"
          alt="Instituto Ashaika Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1F44]/85 via-[#0A1F44]/70 to-[#0A1F44]/80"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44]/60 via-transparent to-transparent"></div>
      </div>

      {/* Decorative golden orb */}
      <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-[#D4AF37]/10 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-1/3 left-1/4 w-64 h-64 rounded-full bg-[#D4AF37]/8 blur-2xl pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className={`inline-flex items-center gap-2 border border-[#D4AF37]/60 text-[#D4AF37] text-xs md:text-sm font-medium px-4 py-2 rounded-full mb-6 md:mb-8 transition-all duration-700 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse"></span>
            Instituto Líder en Terapias Alternativas en México
          </div>

          {/* Main Title */}
          <h1
            className={`text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6 transition-all duration-700 delay-100 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Transforma tu vida,
            <br />
            <span className="text-[#D4AF37]">tu salud</span> y tu
            <br />
            realidad desde la raíz
          </h1>

          {/* Subtitle */}
          <p
            className={`text-white/80 text-base md:text-lg lg:text-xl leading-relaxed mb-8 md:mb-10 max-w-xl transition-all duration-700 delay-200 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            Reprograma tu mente, tu cuerpo y tu energía con técnicas científicas y energéticas avaladas por resultados reales. Formación profesional que transforma vidas.
          </p>

          {/* CTA Buttons */}
          <div
            className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-300 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            <a
              href="https://wa.me/523325077743?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20los%20cursos%20del%20Instituto%20Ashaika"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 bg-[#D4AF37] text-[#0A1F44] font-bold text-base px-8 py-4 rounded-full hover:bg-[#c9a42e] hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Agenda tu Lugar
            </a>
            <button
              onClick={() => {
                const el = document.querySelector("#cursos");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="flex items-center justify-center gap-2 border-2 border-white/60 text-white font-semibold text-base px-8 py-4 rounded-full hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Ver Cursos
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Stats */}
          <div
            className={`flex flex-wrap gap-8 mt-12 md:mt-16 transition-all duration-700 delay-500 ${
              visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
            }`}
          >
            {[
              { num: "500+", label: "Alumnos Certificados" },
              { num: "15+", label: "Años de Experiencia" },
              { num: "6", label: "Especialidades" },
              { num: "98%", label: "Satisfacción" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-[#D4AF37]" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {stat.num}
                </div>
                <div className="text-white/70 text-xs md:text-sm mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 animate-bounce">
        <span className="text-xs tracking-widest uppercase">Descubre más</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
